import React, { useState } from "react";
import { Eye, EyeOff, icons, LockKeyhole, Mail } from "lucide-react";
import { Flex, Spinner } from "@chakra-ui/react";

import { useDispatch } from "react-redux";

import { AdminSingInApi } from "./../../../../redux/reduxApi/SingIn&SingUp/AdminSinginApi";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import NavBar from "../../../../navbar/Navbar";
import {FaCircleUser} from "react-icons/fa";
import {FaRegUserCircle} from "react-icons/fa";
export default function AdminSignIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleShowHide = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await dispatch(AdminSingInApi(formData));
      console.log("Admin Signin Response:", response);
      setLoading(false);
      if (response.payload.data.success) {
        toast.success("Admin Signin Successfully");
        // Navigate to admin dashboard
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 1500);
      } else {
        toast.error(response.payload.data.message);
      }
    } catch (error) {
      console.error("Error signing in:", error);
      toast.error("Error signing in: Please try again.");
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex items-center justify-center   min-h-screen bg-gray-100">
        <div className=" max-w-lg p-6 bg-gray-50 w-100  shadow-xl  border rounded-3xl">
          <div className="w-full flex justify-center">
            <FaRegUserCircle size={70} />
          </div>

          <h2 className="text-2xl font-bold text-center p-1 ">Admin Log In</h2>
          <form className="space-y-8 px-4 py-3  " onSubmit={handleSubmit}>
            <div>
            <label className="block font-medium text-[17px] my-1 text-gray-700">
              Email address
            </label>
            <div  className=" flex items-center w-full active:shadow-lg border border-blue-400 rounded-xl ">
              <span className="flex items-center ml-2 mr-1 text-gray-500 ">
                <Mail className="size-5" />
              </span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter  email"
                className=" flex-grow outline-none border-0 px-2 py-2 bg-transparent rounded-xl  text-gray-600 border-blue-900"
                disabled={loading}
              ></input>
            </div>

            </div>

            <div>
              <label className="block font-medium text-[17px] my-1 text-gray-700">
                Password
              </label>
              <div className="flex items-center border w-full active:shadow-lg rounded-xl ">
                <span className="flex items-center ml-2 mr-1  text-gray-500 ">
                  <LockKeyhole className="size-5" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  className=" flex-grow outline-none border-0 w-full bg-transparent text-gray-600 border-blue-900  px-2 py-2"
                  disabled={loading}
                />
                <span
                  onClick={handleShowHide}
                  className="cursor-pointer py-2 px-2"
                >
                  {showPassword ? <Eye /> : <EyeOff />}
                </span>
              </div>
            </div>

            <button
              type="submit"
              className="flex w-full  items-center justify-center bg-[#f97316] py-3 h-12 text-white   gap-2 signinn-button "
              
            >
              {loading ? (
                <>
                  {" "}
                  <Flex
                    justifyContent={"center"}
                    alignItems={"center"}
                    gap={"2"}
                  >
                    <Spinner size={"sm"} /> <span>Loading..</span>
                  </Flex>{" "}
                </>
              ) : (
                "Sign In"
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
